const model = {
    name: 'Highlight',
    properties: {
        fields: { type: 'array', required: true },
        fragment_size: {},
        post_tag: { type: 'string' },
        pre_tag: { type: 'string' },
    },
};
export default model;
